import { useClient } from '@liveblocks/react'
import { useEffect } from 'react'
import {
  reconnectDisconnectedLiveblocksRooms,
  subscribeMedplumAccessTokenRefresh,
} from '#src/components/liveblocksMedplumRefresh.ts'

export function ReconnectLiveblocksOnMedplumRefresh(): null {
  const client = useClient()
  useEffect(() => {
    return subscribeMedplumAccessTokenRefresh(() => {
      reconnectDisconnectedLiveblocksRooms(client)
    })
  }, [client])
  return null
}
